import { z } from 'zod'

export const reloginSchema = z.object({
  password: z
    .string()
    .min(6, 'A senha deve ter no mínimo 6 caracteres.')
    .nonempty('Senha é obrigatória.'),
})

export type ReloginFormValues = z.infer<typeof reloginSchema>
